import { SPAConfig } from "@sphtech/neuron";

// Neuron Configuration
export const NEURON_URL = import.meta.env.VITE_NEURON_URL as string;
export const NEURON_TOKEN = import.meta.env.VITE_NEURON_TOKEN as string;

export const neuronConfig: SPAConfig = {
  trackedSPAEvents: [
    {
      eventType: "elementVisible",
      selector: "div[id^='sph_cdp_'], div[id^='dfp-ad-']",
    },
  ],
  sessionApiUrl: NEURON_URL,
  sessionApiToken: NEURON_TOKEN,
};
